import { MapPin, Phone, MessageCircle, CalendarHeart, Navigation } from "lucide-react";
import { DORIE_URL, WHATSAPP_URL, PHONE_TEL, PHONE_DISPLAY, MAPS_URL } from "../constants";
import { Reveal } from "./Reveal";

export const Contact = () => (
    <section
        id="contact"
        data-testid="contact-section"
        className="scroll-mt-24 bg-white py-20 lg:py-28"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
                <Reveal>
                    <p className="mb-3 text-sm font-bold text-miam-rose">
                        يسعدنا سماعك
                    </p>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                        تواصلي مع <span className="italic text-miam-rose">ميام</span>
                    </h2>
                    <p className="mt-6 text-base text-miam-muted leading-loose">
                        إذا كنت تحتارين في اختيار العلاج المناسب، أرسلي رسالة
                        إلى مياسة عبر واتساب وسنساعدك في اختيار الجلسة أو الباقة
                        التي تناسب احتياجاتك.
                    </p>

                    <div className="mt-8 space-y-4">
                        <div className="flex items-center gap-4">
                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-miam-green/12 text-miam-green-dark">
                                <MapPin className="h-5 w-5" aria-hidden="true" />
                            </span>
                            <div>
                                <p
                                    data-testid="contact-location"
                                    className="text-base font-medium text-miam-dark"
                                >
                                    يركا، بالقرب من مدرسة الأمل
                                </p>
                                <a
                                    href={MAPS_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="contact-maps-link"
                                    className="mt-1 inline-flex items-center gap-1.5 text-sm font-bold text-miam-green-dark transition-colors duration-300 hover:text-miam-rose"
                                >
                                    <Navigation className="h-3.5 w-3.5" aria-hidden="true" />
                                    الاتجاهات عبر خرائط جوجل
                                </a>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-miam-rose/15 text-miam-rose">
                                <Phone className="h-5 w-5" aria-hidden="true" />
                            </span>
                            <a
                                href={PHONE_TEL}
                                data-testid="contact-phone-link"
                                dir="ltr"
                                className="text-base font-medium text-miam-dark transition-colors duration-300 hover:text-miam-green"
                            >
                                {PHONE_DISPLAY}
                            </a>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="rounded-3xl bg-miam-cream p-9 soft-shadow-sm lg:p-12">
                        <h3 className="font-heading text-xl font-bold text-miam-dark">
                            كيف تحبين أن نبدأ؟
                        </h3>
                        <div className="mt-8 flex flex-col gap-4">
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-whatsapp-button"
                                className="inline-flex items-center justify-center gap-3 rounded-full bg-miam-green px-8 py-4 text-base font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-green-dark hover:shadow-lg"
                            >
                                <MessageCircle className="h-5 w-5" aria-hidden="true" />
                                واتساب – للاستفسار
                            </a>
                            <a
                                href={PHONE_TEL}
                                data-testid="contact-call-button"
                                className="inline-flex items-center justify-center gap-3 rounded-full border-2 border-miam-green px-8 py-[14px] text-base font-bold text-miam-green-dark transition-[background-color,color,transform] duration-300 hover:-translate-y-1 hover:bg-miam-green hover:text-white"
                            >
                                <Phone className="h-5 w-5" aria-hidden="true" />
                                اتصلي بنا
                            </a>
                            <a
                                href={DORIE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-booking-button"
                                className="inline-flex items-center justify-center gap-3 rounded-full bg-miam-rose px-8 py-4 text-base font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-miam-rose-dark hover:shadow-lg"
                            >
                                <CalendarHeart className="h-5 w-5" aria-hidden="true" />
                                احجزي موعداً
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.1}>
                <img
                    src="/clinic-space.jpg"
                    alt="مساحة الاستقبال الدافئة في عيادة ميام"
                    data-testid="contact-clinic-image"
                    loading="lazy"
                    className="mt-16 w-full rounded-[2.5rem] object-cover object-center max-h-[480px] soft-shadow"
                />
            </Reveal>
        </div>
    </section>
);
